import React from 'react';
import { ConfirmationItemDescription } from './ConfirmationItemDescription';
import { faEdit, faHouse, faInbox, faLanguage, faMoneyBill, faStamp } from '@fortawesome/pro-regular-svg-icons';
import { Show } from '../../../../shared/Show';
import { eSigningMethod } from '../../../../../types/signingAppointment/eSigningMethod';
import { useDeriveConfirmationValues } from './useDeriveConfirmationValues';
import { CreateSigningAppointmentFormData } from './convertToCreateSigningAppointmentRequest';
import { attorneyOrNotary } from '../../../../../utilities/order/scheduling/attorneyOrNotary';

export const ConfirmationDisplay: React.FC<{
  wizardFormData: CreateSigningAppointmentFormData;
}> = ({ wizardFormData }) => {
  const { signingMethod, isSignatureSyncAppointment, isDigitalScheduling } = wizardFormData;
  const isDigitalSchedulingNotaryDraft =
    isDigitalScheduling && signingMethod === eSigningMethod.notaryOnly && !isSignatureSyncAppointment;
  const { signingMethodValue, signingTypeValue, languageValue, propertyTypeValue, notaryValue, rateValue } =
    useDeriveConfirmationValues(wizardFormData, isDigitalSchedulingNotaryDraft);

  const shouldShowRateValue =
    signingMethod !== eSigningMethod.thirdPartyNotary && signingMethod !== eSigningMethod.wetSign;
  const shouldShowNotaryBlock = signingMethod !== eSigningMethod.eSign && signingMethod !== eSigningMethod.wetSign;

  return (
    <section className={'mt-2'}>
      <div className={'mb-4 flex'}>
        <ConfirmationItemDescription
          icon={faInbox}
          label={'Signing Method'}
          value={signingMethodValue}
          isDefaultWidth={shouldShowRateValue}
        />
        <ConfirmationItemDescription
          icon={faEdit}
          label={'Signing Type'}
          value={signingTypeValue}
          isDefaultWidth={shouldShowRateValue}
        />
        <Show when={shouldShowRateValue}>
          <ConfirmationItemDescription
            icon={faLanguage}
            label={'Language'}
            value={languageValue}
            isDefaultWidth={shouldShowRateValue}
          />
        </Show>
        <ConfirmationItemDescription icon={faHouse} label={'Prop Type'} value={propertyTypeValue} />
      </div>
      <Show when={shouldShowNotaryBlock}>
        <div className={'flex'}>
          <ConfirmationItemDescription
            icon={faStamp}
            label={attorneyOrNotary(wizardFormData.signingMethod)}
            value={isSignatureSyncAppointment ? 'Signature Sync' : notaryValue}
          />
          <Show
            when={
              !isSignatureSyncAppointment &&
              wizardFormData.signingMethod !== eSigningMethod.thirdPartyNotary &&
              !isDigitalSchedulingNotaryDraft
            }
          >
            <ConfirmationItemDescription icon={faMoneyBill} label={'Rate'} value={rateValue} />
          </Show>
        </div>
      </Show>
    </section>
  );
};
